import { useDonationNavigation } from '../libs/useDonationNavigation';
import { useDebitContext } from './useDebitContext';

interface UseDebitPaymentResult {
    initDebitPayment: (submissionId: string) => void;
}

const useDebitPayment = (): UseDebitPaymentResult => {
    const { nextStep } = useDonationNavigation();
    const { setPaymentData } = useDebitContext();

    const initDebitPayment = (submissionId: string): void => {
        setPaymentData({ submissionId });
        nextStep();
    };

    return { initDebitPayment };
};

export default useDebitPayment;
